import { RESET_STORE, SET_TOKEN } from "../types";
// const sessionToken = sessionStorage.getItem("personalStudioAccessToken")
//   ? JSON.parse(sessionStorage.getItem("personalStudioAccessToken"))
//   : "";
const localToken = localStorage.getItem("personalStudioAccessToken")
  ? JSON.parse(localStorage.getItem("personalStudioAccessToken"))
  : "";
const initialState = {
  access_token: localToken || "",
  refresh_token: "",
};

export const tokenReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_TOKEN:
      return { ...state, ...payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
